export const isNil = (value: any): boolean => (
  value === null || value === undefined
);

export default undefined;